import { render, staticRenderFns } from "./InstantBackground.vue?vue&type=template&id=b59a2c0e&"
import script from "./InstantBackground.vue?vue&type=script&lang=js&"
export * from "./InstantBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports